import { Box } from "@mui/material";
import { DotLegalDialog, DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { Trans } from "react-i18next";
import { useArchiveRiskObservationDialog } from "./ArchiveRiskObservationDialog.hooks";

export interface IArchiveRiskObservationDialog {
    observationId: string;
    observationName: string;
    onArchived: () => void;
    onDialogClose: () => void;
}

function ArchiveRiskObservationDialog(props: IArchiveRiskObservationDialog) {
    const { translateString } = useTranslation();
    const { archiveObservation, inProgress } = useArchiveRiskObservationDialog(props);

    return (
        <DotLegalDialog
            open
            size="sm"
            header={translateString("archiveObservation")}
            buttonOkText={translateString("archive")}
            onOkClick={archiveObservation}
            onDialogClose={props.onDialogClose}
            inProgress={inProgress}
        >
            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <DotLegalHeader center headerStyle="small" fontWeight={400}>
                    <Trans i18nKey="archiveObservationDialogText" values={{ name: props.observationName }} />
                </DotLegalHeader>
            </Box>
        </DotLegalDialog>
    );
}

export default ArchiveRiskObservationDialog;
